export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'kanban_manage',
  'kanban_view',
  'commission_import_manage',
];

export const ROLES = ['agent', 'administrator', 'supervisor', 'diretor'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

// Visibilidade das abas da tela de Conversas (ponto único; ver ChatList.vue →
// assigneeTabItems). Gating por permissão (OR): a aba aparece se o usuário tiver
// QUALQUER das permissions listadas.
//   - "Minhas" (me): todos os papéis.
//   - "Todas" (all) / "Não atribuídas" (unassigned): supervisor/gerente(admin)/diretor —
//     NÃO o agente puro (agente usa "Minhas" + a Fila de Atendimento). O escopo
//     por equipe do supervisor é aplicado pelo backend (ConversationFinder).
// Um agente com a permissão individual conversation_manage/unassigned_manage
// também passa a ver as abas correspondentes (custom roles).
// As constantes MANAGE_ALL/UNASSIGNED/PARTICIPATING seguem exportadas pois são
// reutilizadas por CustomRoleModal.vue.
export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  all: {
    count: 'allCount',
    permissions: [
      'administrator',
      'supervisor',
      'diretor',
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      'administrator',
      'supervisor',
      'diretor',
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
};
